import { useEffect, useState } from 'react';

import { HopThoai, Nut, OChon } from '../../../ui/index.js';
import { useLuuMucTieu, useMucTieu } from '../api.js';
import { TEN_THU } from './gioThiTruong.js';

export interface DialogMucTieuProps {
  kenh: { value: string; label: string }[];
  onDong: () => void;
}

interface KhungGio {
  weekday: number;
  hour: number;
  minute: number;
}

export function DialogMucTieu({ kenh, onDong }: DialogMucTieuProps) {
  const [channelId, setChannelId] = useState(kenh[0]?.value ?? '');
  const mucTieu = useMucTieu(channelId || undefined);
  const luu = useLuuMucTieu(channelId);

  const [soVideo, setSoVideo] = useState(0);
  const [khung, setKhung] = useState<KhungGio[]>([]);

  useEffect(() => {
    if (!mucTieu.data) return;
    setSoVideo(mucTieu.data.videosPerWeek);
    setKhung(mucTieu.data.preferredSlots ?? []);
  }, [mucTieu.data]);

  function doiKhung(i: number, phan: Partial<KhungGio>) {
    setKhung((truoc) => truoc.map((k, j) => (i === j ? { ...k, ...phan } : k)));
  }

  return (
    <HopThoai
      title="Tần suất mục tiêu"
      rong="md"
      onDong={onDong}
      chanHop={
        <>
          {luu.isError && (
            <p role="alert" className="mr-auto self-center text-phu text-bad-chu">
              {luu.error.message}
            </p>
          )}
          <Nut kieu="phu" onClick={onDong}>
            Huỷ
          </Nut>
          <Nut
            kieu="chinh"
            disabled={!channelId}
            dangChay={luu.isPending}
            onClick={() => {
              luu.mutate({ videosPerWeek: soVideo, preferredSlots: khung }, { onSuccess: onDong });
            }}
          >
            Lưu
          </Nut>
        </>
      }
    >
      <p className="mt-1 text-phu text-chu-mo">
        Số video mỗi tuần và khung giờ vàng của kênh. Giờ nhập theo GMT+7.
      </p>

      <div className="mt-4 space-y-4">
        <OChon
          hienNhan
          label="Kênh"
          value={channelId}
          onChange={setChannelId}
          options={kenh.length > 0 ? kenh : [{ value: '', label: 'Chưa có kênh nào' }]}
          className="w-full"
        />

        <div>
          <label htmlFor="so-video" className="mb-1 block text-phu font-medium text-chu-phu">
            Số video mỗi tuần
          </label>
          <input
            id="so-video"
            type="number"
            min={0}
            max={50}
            value={soVideo}
            onChange={(e) => {
              setSoVideo(Number(e.target.value));
            }}
            className="vung-bam w-full rounded-[10px] border border-vien px-3 text-co-ban text-chu"
          />
        </div>

        <fieldset>
          <legend className="mb-2 text-phu font-medium text-chu-phu">Khung giờ vàng</legend>

          <ul className="space-y-2">
            {khung.map((k, i) => (
              <li key={`${String(i)}-${String(k.weekday)}`} className="flex items-center gap-2">
                <OChon
                  label={`Thứ của khung ${String(i + 1)}`}
                  value={String(k.weekday)}
                  onChange={(v) => {
                    doiKhung(i, { weekday: Number(v) });
                  }}
                  options={TEN_THU.map((t, j) => ({ value: String(j + 1), label: t }))}
                />
                <input
                  aria-label={`Giờ của khung ${String(i + 1)}`}
                  type="time"
                  value={`${String(k.hour).padStart(2, '0')}:${String(k.minute).padStart(2, '0')}`}
                  onChange={(e) => {
                    const [gio = '0', phut = '0'] = e.target.value.split(':');
                    doiKhung(i, { hour: Number(gio), minute: Number(phut) });
                  }}
                  className="vung-bam rounded-[10px] border border-vien px-3 text-co-ban text-chu"
                />
                <Nut
                  kieu="nhe"
                  aria-label={`Xoá khung ${String(i + 1)}`}
                  onClick={() => {
                    setKhung((truoc) => truoc.filter((_, j) => j !== i));
                  }}
                >
                  Xoá
                </Nut>
              </li>
            ))}
          </ul>

          <Nut
            kieu="phu"
            className="mt-2"
            onClick={() => {
              setKhung((truoc) => [...truoc, { weekday: 3, hour: 19, minute: 0 }]);
            }}
          >
            + Thêm khung giờ
          </Nut>
        </fieldset>
      </div>
    </HopThoai>
  );
}
